// Unlimited-only paywall: FREE accounts that have never held a subscription
// see a single Unlimited card on every upgrade surface instead of the tier
// grid, and no trial offer. Started as the ALL-1929 A/B; shipped to every
// eligible user 2026-09.

// Kill switch: restores the full grid and the trial for everyone without a
// code change.
export const UNLIMITED_ONLY_KILLED =
  process.env.REACT_APP_UNLIMITED_ONLY_KILL === "true";

// Kept as the analytics vocabulary (paywall_variant on modal events and the
// context trait) so readout queries written for the A/B keep working:
// unlimited_only = this user got the collapsed grid, control = full grid.
export type TPaywallVariant = "unlimited_only" | "control";

export const paywallVariantOf = (enabled: boolean): TPaywallVariant =>
  enabled && !UNLIMITED_ONLY_KILLED ? "unlimited_only" : "control";

// Eligibility: FREE and never subscribed, of any kind (no trial, paid tier,
// store purchase or gifted tier). Every fulfilment path (Stripe, Apple,
// Google Play, Xsolla) stamps userGroup.paymentDate on the way in, trials
// included, and nothing clears it on downgrade, so a FREE account with no
// paymentDate has never subscribed. Gifted tiers never pay, so they are
// caught by providerName. No user (logged out, still hydrating) fails closed
// to ineligible: before GET_ME lands the atom has no tier, and "no data yet"
// must not read as "never paid".
export type TUnlimitedOnlyEligibilityUser = {
  userGroup?: { type?: string | null; paymentDate?: string | null } | null;
  credits?: { providerName?: string | null } | null;
} | null;
export const isUnlimitedOnlyEligibleUser = (
  user?: TUnlimitedOnlyEligibilityUser,
): boolean => {
  const userGroup = user?.userGroup;
  if (!userGroup?.type) return false;
  if (userGroup.type !== "FREE") return false;
  if (userGroup.paymentDate) return false;
  if (user?.credits?.providerName === "GIFTED") return false;
  return true;
};
